export default "__VITE_ASSET__e614ff11__"